import React from 'react';

export const DText = ({ children, style, className, as = 'p' }) => {
  const Component = as || 'p';

  const combinedStyle = style ? { fontWeight: 'normal', ...style } : { fontWeight: 'normal' };

  if (typeof children === 'string') {
    const lines = children.split(/\r?\n+/).filter(line => line.trim().length > 0);
    return (
      <>
        {lines.map((line, idx) => (
          <Component key={idx} className={className} style={combinedStyle}>{line}</Component>
        ))}
      </>
    );
  }

  const parts = React.Children.toArray(children);
  const allStrings = parts.length > 0 && parts.every(p => typeof p === 'string');
  if (allStrings) {
    const joined = parts.join('');
    const lines = joined.split(/\r?\n+/).filter(line => line.trim().length > 0);
    return (
      <>
        {lines.map((line, idx) => (
          <Component key={idx} className={className} style={combinedStyle}>{line}</Component>
        ))}
      </>
    );
  }

  return <Component className={className} style={combinedStyle}>{children}</Component>;
};

export default DText;

